import { SortDirection } from '../../../../aumico-lib-cpmm-fe/src/lib/enums/sort-direction.enum';
import { MfaSortingProperties } from '../enums/mfa-sorting-properties.enum';

export interface MfaFilter {
    sortBy?: MfaSortingProperties;
    sortOrder?: SortDirection;
}
